module.exports = __webpack_public_path__ + "static/media/about_us@2x.036c38d1.png";